import clsx from 'clsx'
import { useContext, useEffect, useState } from 'react'
import { FiMenu } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useLayout } from '../../core'
// import {Header} from './Header'
import { DefaultTitle } from './page-title/DefaultTitle'
import { MasterDataSyncIndicator, Topbar } from './Topbar'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { imageBaseUrl } from 'src/cms/helpers/constants'
import { Header } from 'antd/es/layout/layout'
import { Button, Divider } from 'antd'
import { FaBars } from 'react-icons/fa'
import { ActiveMenuContex } from '../../MasterLayout'

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { header, aside } = config
  const [logo, setLogo] = useState('')
  const activeMenu: any = useContext(ActiveMenuContex)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const authResp = useSelector((state: any) => state.auth)
  const { user } = authResp
  // While master data syncs the branch slot shows the sync message instead,
  // then falls back to the branch title. A failure is reported separately by
  // MasterDataSyncIndicator, leaving this slot on the branch title.
  const isMasterDataSyncing =
    useSelector((state: any) => state.allMasterDataOptions?.syncStatus) === 'syncing'
  const branchTitle: string | undefined = user?.data?.branch?.title

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])
  const showDrawer = () => {
    activeMenu.setOpen(true)
  }
  return (
    <>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 9,
          boxShadow: 'rgba(122, 122, 122, 0.12) 0px 0.4rem 0.7rem',
        }}
        className='d-flex align-items-center justify-content-between'
      >
        <div className='d-flex align-items-center'>
          <Button
            type='primary'
            size='large'
            icon={<FaBars />}
            style={{ marginRight: '1rem' }}
            onClick={showDrawer}
          />
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className=' logo'
              height={45}
              // src='/media/logos/global-ime-logo-svg.jpg'
              src={`${imageBaseUrl}/${logo}` || `/media/logos/global-ime-logo-svg.jpg`}
            />
          </Link>
        </div>
        <div className='d-flex align-items-center gap-1'>
          <MasterDataSyncIndicator />
          {(isMasterDataSyncing || branchTitle) && (
            <div
              className={clsx('amnil-branch', isMasterDataSyncing && 'is-syncing')}
              role='status'
              aria-live='polite'
            >
              <span className='amnil-branch__label'>
                {isMasterDataSyncing ? 'Please wait' : 'Branch'}
              </span>
              <h4 className='amnil-branch__title m-0 p-0'>
                {isMasterDataSyncing ? 'Masterdata Syncing...' : branchTitle}
              </h4>
            </div>
          )}
          <Divider type='vertical' style={{ height: '4em' }} />
          <Topbar />
        </div>
      </Header>
    </>
  )
}
